import { type InsuranceApiClientType } from '@/libs/api/insurance/insurance-client.ts'
import type {
  DeviceClassProductOfferMapping,
  ProductOfferResponse,
  ProductSpecificationRequest,
  ProductSpecificationResponse
} from '@/libs/api/insurance/insurance.types.ts'

type DeviceClassOfferDto = {
  deviceClassId: string
  offers: ProductOfferResponse[]
}

export const useInsuranceService = (client: InsuranceApiClientType) => {
  async function mapOffersToDeviceClass(
    deviceClassIds: string[]
  ): Promise<DeviceClassProductOfferMapping> {
    const allResults = (await fetchOffersForDeviceClasses(deviceClassIds)) ?? []

    return allResults.reduce((acc, dto: DeviceClassOfferDto) => {
      acc[dto.deviceClassId] = dto.offers
      return acc
    }, {} as DeviceClassProductOfferMapping)
  }

  async function fetchOffersForDeviceClasses(
    deviceClassIds: string[]
  ): Promise<DeviceClassOfferDto[] | undefined> {
    const fetchOffers = deviceClassIds.map(async (deviceClassId) => {
      const offers = await client.getDeviceClassOffer(deviceClassId, 0)

      return {
        deviceClassId: deviceClassId,
        offers
      }
    })

    return await Promise.all(fetchOffers)
  }

  async function fetchProductSpec(
    params: Omit<ProductSpecificationRequest, 'is_commercial' | 'is_refurbished'>
  ): Promise<ProductSpecificationResponse> {
    const response = await client.getProductSpecifications({
      ...params,
      is_commercial: 0,
      is_refurbished: 0
    })
    return response.data as ProductSpecificationResponse
  }

  return {
    mapOffersToDeviceClass,
    fetchProductSpec
  }
}
